import { parseEnv } from './env.schema';

/**
 * 환경변수의 유일한 출입구. 다른 파일에서 `import.meta.env` 를 읽지 않는다(lint 로 막는다).
 * 모듈을 불러올 때 검증하므로 값이 틀리면 앱이 뜨지 않는다.
 */
const parsed = parseEnv(import.meta.env);

export const env = {
  appEnv: parsed.VITE_APP_ENV,
  logLevel: parsed.VITE_LOG_LEVEL,
  errorReportDsn: parsed.VITE_ERROR_REPORT_DSN,
  analyticsKey: parsed.VITE_ANALYTICS_KEY,
  isDevServer: import.meta.env.DEV,
  /** 앱이 올라간 기준 경로(Vite `base`, 끝 `/`). 서비스는 `/`, 경로 아래에 올리는 빌드(프리뷰)는 그 경로 */
  basePath: import.meta.env.BASE_URL,
} as const;

export type AppEnv = typeof env;
